export const profilePath = (username: string): string => `/profile/${username}`;

export const userSettingsPath = (): string => '/settings';

export const settingsApiKeysPath = (): string => '/settings#apikeys';

export const accountSettingsApiKeysPath = (organizationName: string): string =>
  accountSettingsTab(organizationName, 'api-keys');

export const subscriptionsPath = (): string => '/subscriptions';

export const automationsPath = (): string => '/automations';

const accountSettingsTab = (
  organizationName: string,
  tabName: string
): string =>
  `/account-settings/${encodeURIComponent(organizationName)}/${tabName}`;

export const accountSettingsMembersPath = (organizationName: string): string =>
  accountSettingsTab(organizationName, 'members');

export const accountSettingsTeamsPath = (organizationName: string): string =>
  accountSettingsTab(organizationName, 'teams');

export const accountSettingsBillingPath = (organizationName: string): string =>
  accountSettingsTab(organizationName, 'billing');

export const accountSettingsSettingsPath = (organizationName: string): string =>
  accountSettingsTab(organizationName, 'settings');
